import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import { AppConfigService } from '@core';

export interface GenerateCaseAiSummaryRequest {
  prompt: string;
  apiKeyHint?: string;
}

export interface CaseAiSummaryResponse {
  id: number;
  caseId: number;
  summary: string;
  recentUpdates: string[];
  renderedPrompt?: string;
  createdOn: string;
  updatedOn: string;
  isStale?: boolean;
}

@Injectable({ providedIn: 'root' })
export class AiSummaryApiService {
  private readonly _http = inject(HttpClient);
  private readonly _config = inject(AppConfigService);
  private readonly _apiUrl = `${this._config.versionedApiUrl}/cases`;

  public getSummary(caseId: string): Observable<CaseAiSummaryResponse | null> {
    return this._http
      .get<CaseAiSummaryResponse>(`${this._apiUrl}/${caseId}/ai-summary`)
      .pipe(
        catchError(() => of(null))
      );
  }

  public generateSummary(
    caseId: string,
    request: GenerateCaseAiSummaryRequest
  ): Observable<CaseAiSummaryResponse> {
    return this._http.post<CaseAiSummaryResponse>(
      `${this._apiUrl}/${caseId}/ai-summary`,
      request
    );
  }
}
